module.exports = __webpack_public_path__ + "static/preview-image-e66fc1e00744916766ee6e82d7117634.jpg";